export default "__VITE_ASSET__gHRvOynd__"